import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { accessRole } from '../../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { cancelToken } from "../../../../../services/adapters/kepegawaian/kursusService"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CreateBloc from './Blocs/CreateBloc'
import RegionBloc from '../Index/Blocs/RegionBloc'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
let peg_nip = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_nip : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
    peg_nip = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_nip : "";
}


class CreateView extends Component {

    regionBloc = new RegionBloc()
    createBloc = new CreateBloc()
    source
    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            domicile: 0,
            regionOption: [],
            provinceOption: [],
            cityOption: [],
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'document') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                employee_nip: peg_nip,
              employee_uuid : peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.regionBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.regionBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.regionBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.regionBloc.fetchRegion(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadRegion()
        this.loadProvince()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.regionBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.regionBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })


        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.regionBloc.regionProvinceChannel?.unsubscribe()
        this.regionBloc.regionChannel?.unsubscribe()
        this.regionBloc.regionCityChannel?.unsubscribe()
        this.createBloc.createChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="kursus"/> */}

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Kursus</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldNama"
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Kursus <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="courses_name"
                                                    placeholder="Nama Kursus"
                                                    errorMessage="Masukkan Nama Kursus"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldNama"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <hr/>
                                        <Label># Tempat Kursus</Label>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Dalam / Luar Negeri<span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="courses_domicile"
                                                    errorMessage="Pilih Domisili"
                                                    options={[{ value: 0, label: 'Dalam Negeri' }, { value: 1, label: 'Luar Negeri' }]}
                                                    defaultValue={this.state.domicile}
                                                    onChange={opt => this.setState({ domicile: opt.value })}
                                                    placeholder="Pilih Domisili"
                                                    validate={{ required: { value: true } }}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <AvField 
                                                    type="hidden" 
                                                    name="courses_country_uuid" 
                                                    value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid} 
                                                />
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Provinsi <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="courses_province_uuid"
                                                            errorMessage="Pilih Provinsi"
                                                            onChange={value => this.getCity(value.region_uuid)}
                                                            options={this.state.provinceOption}
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid" 
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Provinsi"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="courses_city_uuid"
                                                            errorMessage="Pilih Kota Lahir"
                                                            options={this.state.cityOption} 
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid"
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Kota Lahir"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="courses_country_uuid"
                                                            errorMessage="Pilih Negara"
                                                            options={this.state.regionOption}
                                                            optionValue="region_uuid"
                                                            optionLabel="region_name"
                                                            placeholder="Pilih Negara"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>                                           
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField
                                                            name="courses_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Masukkan Kota"
                                                            className="form-control"
                                                            validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                            id="place_of_birth_city_text"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPenyelenggara"
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="courses_organizer"
                                                    placeholder="Nama Penyelanggara"
                                                    errorMessage="Masukkan Penyelanggara"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldPenyelenggara"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglMulai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="courses_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglMulai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSelesai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="courses_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSelesai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                File Kursus <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="document"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="10">
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to="/kepegawaian/home.html?kursus">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?kursus'/>
                : null }
            </Fragment>
        )
    }

}

export default CreateView